export interface IRevisedTypo {
	['head']: string;
	['typo_20b']: string;
	['typo_18b']: string;
	['typo_16b']: string;
	['typo_16m']: string;
	['typo_14m']: string;
}

const revised_typo: IRevisedTypo = {
	head: `
        font-size: 40px;
        font-weight: 800;
        line-height: 50px;
    `,
	typo_20b: `
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
    `,
	typo_18b: `
        font-size: 18px;
        font-weight: 700;
        line-height: 26px;
    `,
	typo_16b: `
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    `,
	typo_16m: `
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    `,
	typo_14m: `
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
    `,
};

export default revised_typo;
